<template>
  <a-card :bordered="false">
    <SmallSquare content="1.可针对指定商品显示对应的溯源模板；
2.已关联的商品修改模板，需先在关联商品中删除后再绑定新模板；
3.没有配置的商品显示默认溯源页面" class="m-b-10" />
  <a-form ref='form' :model='search' :style="{'marginBottom':'25px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="模板名称" name='name'>
      <a-input v-model:value="search.name" :style="{width:'300px'}" placeholder="请输入模板名称" />
    </a-form-item>
    <a-form-item label="商品名称" name='product_name'>
      <a-input v-model:value="search.product_name" :style="{width:'300px'}" placeholder="请输入商品名称" />
    </a-form-item>
    <a-form-item label="模板类型" name='tem_sy_type' >
      <a-select v-model:value="search.tem_sy_type" :style="{width:'140px'}" placeholder="全部">
        <a-select-option value="">全部</a-select-option>
        <!-- <a-select-option :value="1">系统模板</a-select-option> -->
        <a-select-option :value="2">定制模板</a-select-option>
        <a-select-option :value="0">自定义模板</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" htmlType='submit'>搜索</a-button>
    </a-form-item>
  </a-form>
  <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
    <template v-slot:defaultSwitch="{ record }">
      <a-switch :checkedValue="1" :unCheckedValue="0" v-model:checked="record.is_default" @change="changes(record)" />
    </template>
    <template v-slot:name="{ record }">
      <a href="javascript:;" @click="$router.push({path:'/qrcode/template/create',query:{type:record.type,id:record.id,is_default:record.is_default,mark:record.mark}})" class="m-r-15">{{record.name}}</a>
    </template>
    
    <!-- settingProductAssociation -->
    <template v-slot:product="{ record }">
     {{record.bind_product_num}}款商品<a-button @click="targetProductVisible(record)" class="m-l-10">查看商品</a-button>
    </template>
    <template v-slot:action="{ record }">
      <a href="javascript:;" v-has:crateProductAssociation="()=>{crateProduct(record)}" class="m-r-15">添加商品</a>
          
    </template>
  </a-table>
  <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
  </a-card>

  <!-- 查看商品 -->
  <a-modal :keyboard="false" v-model:visible="productVisible" centered :width='1100' destroyOnClose>
    <product :currentData="productData" v-on:update="pageCurrentChange"  />
  </a-modal>
  <!-- 添加商品 -->
  <a-modal :keyboard="false" v-model:visible="createproductVisible" centered :width='1100' destroyOnClose title="添加商品" :footer="null">
    <!-- :selectList='goodList' -->
       <selectGood v-on:select="goodSelect"  :checkout="true" :templateSelect="true" />
  </a-modal>
</template>

<script>
import useTableSearch from "@/hooks/useTableSearch";
import product from "./components/product";
import { ref } from "@vue/reactivity";
import { get_trace_templates_list,setDefault,bind_product } from "@/api/qrcodeActivitys";
import { onMounted } from "@vue/runtime-core";
import { iscode } from '../../../utils/app';
import { message } from 'ant-design-vue';
const columns = [
  {
    title: "模板名称",
    dataIndex: "name",
    key: "name",
    slots: { customRender: "name" },
  },
  {
    title: "模板类型",
    dataIndex: "affiliation_text",
    key: "affiliation_text",
  },
  {
    title: "是否设为默认",
    dataIndex: "default",
    key: "default",
    slots: { customRender: "defaultSwitch" },
  },
  {
    title: "关联商品",
    dataIndex: "product",
    key: "product",
    slots: { customRender: "product" },
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    slots: { customRender: "action" },
  },
];
const defSearch = { limit: 10, page: 1, type: 3, name: "",product_name:"",tem_sy_type:"" };
export default {
  components: { product },
  setup() {
    const {
      pageCurrentChange,
      pageSizeChange,
      search,
      list,
      initData,
      total,
      pageSearchChange,
      listLoading,
    } = useTableSearch({ data: defSearch });
    const tableHoosks = {
      pageCurrentChange,
      pageSizeChange,
      search,
      initData,
      list,
      total,
      pageSearchChange,
      listLoading,
    };
    onMounted(() => {
      tableHoosks.initData(get_trace_templates_list, search.value);
    });
    // 查看
    const productHooks = () => {
      // 弹窗
      const productVisible = ref(false);
      // 产品数据
      const productData = ref();
      // 方法
      const targetProductVisible = (data) => {
        productData.value = data;
        productVisible.value = true;
      };
      return {
        productVisible,
        targetProductVisible,
        productData,
      };
    };
    // 添加商品
    const createProductHooks = () => {
      const createproductVisible = ref(false);
      const flagData = ref({});
      const crateProduct = (data) => {
        flagData.value = data ;
        createproductVisible.value = true;
      };
      const goodSelect=async (data)=>{
        console.log(data)
        var product_ids=data.map(v=>v.id)
        let result=await bind_product({product_ids,trace_template_uuid:flagData.value.template_uuid}).then(res=>res.data).catch(error=>error)
        if(iscode(result,true)){
         tableHoosks.initData(get_trace_templates_list, search.value);
        createproductVisible.value = false;
        }
      }
      return {
        createproductVisible,
        crateProduct,
        goodSelect
      };
    };
    // 切换是否默认
    const changes=async (data)=>{
      // if(!data.is_default){

      //    message.error("无法取消默认配置")
      //     tableHoosks.initData(get_trace_templates_list, search.value);
      //     return
      // }
      let result=await setDefault({template_id:data.id,is_default:data.is_default}).then(res=>res.data).catch(error=>error)
      iscode(result,true)
      tableHoosks.initData(get_trace_templates_list, search.value);
    }
    return {
      ...tableHoosks,
      ...productHooks(),
      ...createProductHooks(),
      columns,
      changes
    };
  },
};
</script>